import { render, staticRenderFns } from "./lowerExpenseManage.vue?vue&type=template&id=3e228b54&scoped=true&"
import script from "./lowerExpenseManage.vue?vue&type=script&lang=js&"
export * from "./lowerExpenseManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e228b54",
  null
  
)

export default component.exports